<div class="fs-1 text-primary font-bold text-center">
  Děkujeme!
</div>
<div class="text-center mb-4">
  Vážíme si Vašeho zájmu a těšíme se na objednávku.
</div>

<div class="d-grid">
  <button class="btn btn-lg w-full rounded-pill btn-outline-primary btn-block" (click)="onSubmit()">Další kalkulace</button>
</div>
